import {Component, Input, OnInit} from '@angular/core';
import {Competitor, Country, EventItem, Lookups, PaymentStatus, Race, RegistrationStatus} from "@model";
import {LocalizedDatePipe} from "@pipes";
import {TranslocoService} from "@ngneat/transloco";
import {MyUpcomingHeadingType} from "@components";

@Component({
  selector: 'app-my-upcoming-race',
  templateUrl: './my-upcoming-race.component.html',
  styleUrl: './my-upcoming-race.component.scss'
})
export class MyUpcomingRaceComponent implements OnInit  {
  @Input() race: Race | undefined;
  @Input() event: EventItem | undefined
  @Input({required: true}) languages: Lookups[] = [];
  @Input({required: true}) countries: Country[] = [];

  status: PaymentStatus = PaymentStatus.NO_PAYMENT;
  localizedDatePipe: LocalizedDatePipe;

  constructor(public translocoService: TranslocoService) {
    this.localizedDatePipe = new LocalizedDatePipe(translocoService);
  }

  ngOnInit() {
  }

  onContinueWithPayment(competitor: Competitor) {
    if (
        competitor.registration?.registrationStatus === RegistrationStatus.RESERVED &&
        competitor.registration.endDateForPayment &&
        new Date(competitor.registration.endDateForPayment).getTime() > (new Date()).getTime()
    ) {
      //todo
      //go to payment
    }
  }

  displayPayButton(competitor: Competitor) {
    return  (
        competitor.registration?.registrationStatus === RegistrationStatus.RESERVED &&
        competitor.registration.endDateForPayment &&
        new Date(competitor.registration.endDateForPayment).getTime() > (new Date()).getTime()
    )
  }


  protected readonly MyUpcomingHeadingType = MyUpcomingHeadingType;
  protected readonly PaymentStatus = PaymentStatus;
  protected readonly RegistrationStatus = RegistrationStatus;


}
